export const titleData = [
  { _id: 0, title: "Mr." },
  { _id: 1, title: "Miss." },
  { _id: 2, title: "Mrs." },
];
